import React, { useCallback, useEffect, useState } from 'react';
import ChildrenBlock from './children-block';
import { useFetchLoginStatus, useFetchModuleList } from '@src/services/session';
import ItemBlock from './item-block';
import { message } from 'antd';
import './portal.scss';
var prefixCls = 'portal-page';
var DashboardPage = function (props) {
    var token = sessionStorage.getItem('token');
    var _a = useState({ key: props.keyword, token: token }), args = _a[0], setArgs = _a[1];
    var _b = useState({ appid: '', t: '' }), p_k = _b[0], setPk = _b[1];
    /** 查询登录状态 */
    var _c = useFetchLoginStatus(p_k.appid, p_k.t), isLoginFetching = _c.isFetching, isLoginError = _c.isError, loginResponse = _c.data, isFetched = _c.isFetched;
    /** 查询模块列表 */
    var _d = useFetchModuleList(args), isModuleFetching = _d.isFetching, isModuleError = _d.isError, moduleError = _d.error, moduleData = _d.data;
    var modules = React.useMemo(function () {
        var _a;
        return ((_a = moduleData) === null || _a === void 0 ? void 0 : _a.sysList) || [];
    }, [moduleData]);
    var commonModules = React.useMemo(function () {
        var _a;
        var list = ((_a = moduleData) === null || _a === void 0 ? void 0 : _a.commonList) || [];
        var result = [];
        list.map(function (item, index) {
            if (index < 4) {
                result.push(item);
            }
        });
        return result || [];
    }, [moduleData]);
    var showCommon = commonModules.length > 0;
    var onClickItemBlock = useCallback(function (id) {
        setPk({
            appid: id,
            t: "" + new Date().getTime(),
        });
    }, []);
    useEffect(function () {
        setArgs({ key: props.keyword, token: token });
    }, [props.keyword, token]);
    /** 监听 登录状态 请求状态 */
    useEffect(function () {
        if (isFetched && isLoginFetching === false && isLoginError !== true) {
            var _a = (loginResponse || {}), login = _a.login, appid = _a.appid;
            if (login === true) {
                window.open(__PERSONAL_API__ + "/third/sys?appid=" + appid + "&jwt-token=" + sessionStorage.getItem('token'), '_blank');
            }
            else if (login === false) {
                window.location.href = '/login';
            }
        }
    }, [isFetched, isLoginFetching, isLoginError, loginResponse]);
    // 提示模块错误消息
    useEffect(function () {
        if (isModuleError !== false && typeof moduleError === 'string') {
            message.info(moduleError);
        }
    }, [isModuleError, moduleError]);
    return (React.createElement("div", { className: "page " + prefixCls + "_content" },
        React.createElement("section", null, showCommon ? (React.createElement("div", { className: "children-block" },
            React.createElement("div", { className: "children-block_title" },
                React.createElement("span", null, "\u5E38\u7528"),
                " / ",
                React.createElement("span", null, "Commonly Usually")),
            React.createElement("div", { className: "children-block_children common" }, commonModules.map(function (item) { return (React.createElement(ItemBlock, { data: item, key: item.sysID, onClickItemBlock: onClickItemBlock })); })),
            React.createElement("hr", null))) : (React.createElement("span", null))),
        React.createElement("section", { className: prefixCls + "_main-data" }, isModuleFetching ? (React.createElement("div", null)) : isModuleError ? (React.createElement("div", null)) : modules.length > 0 ? (modules.map(function (child) { return (React.createElement(ChildrenBlock, { data: child, key: child.sysTypeID, onClickItemBlock: onClickItemBlock })); })) : (React.createElement("div", { className: prefixCls + "_no-data" })))));
};
export default React.memo(DashboardPage);
